import { ArbolNodo } from "./arbol-decision.model";
import { PolizaSalud } from "./salud.model";

export interface RecomendadorAgrupacion {
  numOrdenAgrupacion: number;
  txtNombre: string;
  numOrdenPresentacion: number;
  blnRecomendada: boolean;
  blnDental: boolean;
}

export interface RecomendadorColectiva {
  numColectiva: string;
  numOrdenPresentacion: number;
  txtColectiva: string;
  txtSubnombre: string;
  txtDescripcion: string;
  txtCopagos: string;
  urlImagen: string;
  numColectivaPrincipal: string;
  esDescuento: boolean;
  esPack: boolean;
  esDental: boolean;
  esDestacada: boolean;
  codErrorAsociado: string;
}

export interface ColectivasAgrupacion {
  codCanal: string;
  colectivas: RecomendadorColectiva[];
  colectivasAlternativas: RecomendadorColectiva[];
}

export interface AgrupacionPolizasSalud {
  nombreColectivaPadre: string;
  polizasColectivas: PolizaSaludColectiva[];
}

export interface PolizaSaludColectiva{
  polizaSalud: PolizaSalud;
  colectiva: RecomendadorColectiva;
  polizaDescuento?: PolizaSalud;
  colectivaDescuento?: RecomendadorColectiva;
}

export interface CategoriaColectivaIdiomas {
  numColectiva: string;
  codCanal: string;
  codIdioma: string;
  txtColectiva: string;
  urlImagen: string;
  txtCopagos: string;
  txtSubnombre: string;
  txtDescripcion: string;
}

export interface PermisosRecomendador {
  permiteContratar: boolean;
  permiteImprimir: boolean;
}

export interface PreguntaRecomendador {
  codCategoria: string;
  txtCategoria: string;
  opciones: ArbolNodo[];
}

export interface Recomendador {
  idRecomendador: number;
  idArbol: number;
  codCanal: string;
}

export interface ConsultarIdOpcionRecomendador {
  idRecomendador: number;
  idioma: string;
  tipoDocumento: string;
  tipoCliente: string;
  tipoAsistencia?: string;
  hospitalizacion?: string;
  cuadroMedico?: string;
}

export enum ModoRecomendador {
    SENIOR = 'SENIOR',
    NORMAL = 'NORMAL',
    NORMAL_CON_SENIOR = 'NORMAL_CON_SENIOR'
}

export interface ValidacionColectivas {
    colectivas: string[];
    modoRecomendador: ModoRecomendador;
}